export const saasDefaultSetting = {
  show_creationplatform: 'true',
  name: '必优科技',
  source: '必优科技',
  instruct: [
    '帮我创作一份关于北京故宫的PPT',
    '生成一个金融行业年终总结',
    '生成一份自我介绍的PPT案例',
    '帮我生成一份健身计划',
    '生成一份大学生如何做职业规划的'
  ],
  langData: [
    {
      label: '中文简体',
      value: 'zh-CN'
    },
    {
      label: '中文繁体',
      value: 'zh-TW'
    },
    {
      label: 'English',
      value: 'en-US'
    }
  ],
  emptyTips: '快在下方输入框，输入你的PPT主题吧~',
  hellodata: [
    '👋~我是ChatPPT，告诉我你想要生成的PPT内容？',
    '👋试试输入你的主题如：生成一份金融行业分析报告，蓝色色系，科技风格',
    '👋选择合适的内容场景，会让你的内容生成更精准哦',
    '👋文心一言、Deepseek、Kimi、通义千问等平台生成的内容，一键粘贴更简单'
  ],
  isLogEdit: false,
  langValue: 'zh-CN',
  modelData: [
    {
      flag: 'Baidu',
      icon: 'https://image.yoojober.com/users/2025-03/67d2a78847fc0.jpg',
      pick: true,
      en_name: 'Ernie',
      show_id: 'FA335t',
      show_name: '文心一言'
    },
    {
      flag: 'Kimi',
      icon: 'https://image.yoojober.com/users/2025-03/67d23c01057db.jpg',
      pick: true,
      en_name: 'Kimi',
      show_id: '9Zkb2C',
      show_name: 'Kimi'
    },
    {
      flag: 'Spark',
      icon: 'https://image.yoojober.com/users/2025-03/67d23be83068c.jpg',
      pick: true,
      en_name: 'Xunfei Spark',
      show_id: 'unv9Il',
      show_name: '讯飞星火'
    },
    {
      flag: 'Volc',
      icon: 'https://image.yoojober.com/users/2025-03/67d23bc3f11c7.png',
      pick: true,
      en_name: 'Doubao',
      show_id: 'EhVF9M',
      show_name: '豆包'
    },
    {
      flag: 'Stepfun',
      icon: 'https://image.yoojober.com/users/2025-03/67d2a76178330.jpg',
      pick: true,
      en_name: 'Step',
      show_id: 'Jxn2TG',
      show_name: '阶跃星辰'
    },
    {
      flag: 'DeepSeek',
      icon: 'https://image.yoojober.com/users/2025-02/67a960fad69c0.png',
      pick: true,
      en_name: 'DeepSeek',
      show_id: 'FR332a',
      show_name: 'DeepSeek'
    },
    {
      flag: 'TongYi',
      icon: 'https://image.yoojober.com/users/2025-04/6810921217bee.webp',
      pick: true,
      en_name: 'QWen3',
      show_id: 'gdt331',
      show_name: '通义千问'
    }
  ],
  sceneData: [
    {
      icon: '//image.yoojober.com/users/2025-04/67f498d1475c3.png',
      color: '#624810',
      label: '通用场景',
      value: 'normal',
      bgicon: '//image.yoojober.com/users/2025-04/67f498d1475c3.png',
      styleObj: {
        bgcss: {
          '--color1': '176, 233, 255',
          '--color2': '218, 255, 248',
          '--color3': '230, 255, 249',
          '--color4': '194, 239, 255',
          '--color5': '215, 255, 246',
          '--blending': 'hard-light',
          '--circle-size': '80%',
          '--color-interactive': '186, 237, 255'
        },
        rootOBbj: {
          '--qacolor1': '#68D5F3',
          '--qacolor2': '#C4F1FE',
          '--qacolor3': '#114556',
          '--qacolor4': '#85AFBD',
          '--qacolor5': '#97A1B1',
          '--qacolor6': '#1A1A1A',
          '--qacolor7': '#D5EFF3',
          '--qacolor8': '#8EB0B5',
          '--qacolor9': '#64CBE7',
          '--qacolor10': '#FAFFFF',
          '--qacolor11': '#F8F8F8',
          '--qacolor12': '#F1FDFD',
          '--qacolor13': '#FFFFFF',
          '--qacolor14': '166, 234, 255',
          '--chat-right-bgcolor': '#1a1a1a'
        },
        backgroundColor: '',
        backgroundImage: ''
      },
      background: '#FFE6AF',
      only_import: false
    }
  ],
  speedData: [],
  importTags: [
    {
      desc: '输入描述与文档要求(内容/设计)生成PPT',
      icon: '//image.yoojober.com/upload-m/2025-03/67ca6d7005fd2.png',
      name: '主题生成PPT',
      show: 'true',
      instruct: ''
    },
    {
      desc: 'Word、PDF、XMind等30种文件类型',
      icon: '//image.yoojober.com/upload-m/2025-03/67ca6d82d0996.png',
      name: '导入文件生成PPT',
      show: 'true',
      type: 'uploads',
      instruct: '导入文件生成ppt'
    },
    {
      desc: '基于网页链接、微信公众号文档等生成',
      icon: '//image.yoojober.com/upload-m/2025-03/67ca6d922be9e.png',
      name: '网页生成PPT',
      show: 'true',
      instruct: '导入网页链接生成PPT'
    }
  ],
  modelValue: 'DeepSeek',
  sceneValue: 'normal',
  speedValue: '1',
  GenerateDisplay: [
    {
      desc: '对话式生成文档，一句话生成PPT，也可以导入30种文件生成PPT，且可以满足溯源，创建灵感PPT必备。',
      icon: '//image.yoojober.com/users/2025-04/67f498d1475c3.png',
      model: 'generate',
      title: '生成PPT',
      tgtext: '开始生成'
    },
    {
      desc: '基于你上传的文档（pptx/pdf/图片），AI识别并重新全文美化文档，实时渲染，所见即所得。',
      icon: '//image.yoojober.com/users/2025-04/67f498f471d19.png',
      model: 'beautify',
      title: '美化PPT',
      tgtext: '上传美化'
    },
    {
      desc: '将本地文件导入在线PPT，一键分享，并支持PPT实时互动，让表达更加高效。',
      icon: '//image.yoojober.com/users/2025-04/67f4989c93aa5.png',
      model: 'import',
      title: '导入PPT',
      tgtext: '点击导入'
    }
  ],
  isLogEdit_share: false,
  GlobalConfiguration: {
    css: {
      '--yoo-theme-lg': 'linear-gradient(270deg, #6040fc 15%, #e750e6 100%)',
      '--yoo-theme-color': '#4e3eff',
      '--yoo-theme-shadow': '0px 4px 52px 0px rgba(222, 217, 255, 0.51)',
      '--yoo-theme-lgimage': 'linear-gradient(90deg, #FA52E3 0%, #4E3EFF 100%)',
      '--yoo-theme-hover-bg': '#FFF7FF',
      '--yoo-theme-tolgimage':
        'linear-gradient(to right, #fa52e3, #4e3eff, #2e91ff, #ff5ef9)',
      '--yoo-theme-border-color': '#4838ff',
      '--creationplatform-background':
        'linear-gradient(122deg, #4e3eff 2%, #ececff 83%)'
    },
    logo: '//image.yoojober.com/users/2025-07/686c838fddcb1.svg',
    showlogo: true,
    home_desc: '👀输入PPT主题或要求，即可生成你的演示文稿',
    home_title: '就能写好PPT',
    scene_icon: '//image.yoojober.com/users/2025-04/67edfc6332bb7.svg',
    white_logo: '//image.yoojober.com/users/2025-04/680c417fc2355.svg',
    home_banner: '//image.yoojober.com/upload-m/2025-04/6809e486001ff.gif',
    home_p_icon: '//chatppt.test.yoo-ai.com/static/img/home_icon2.148622c6.svg',
    home_p_text: '生成你的',
    home_uptitle: '会说话',
    business_logo: '',
    home_title_tip: '//image.yoojober.com/users/2025-07/686c85babe730.png',
    backgroundColor: '#F5F7F9'
  },
  creation_big_entrance: {
    bg: '//image.yoojober.com/users/2025-05/682afa21def95.png',
    desc: '上传本地PPT文件进行AI一键美化',
    icon: '//image.yoojober.com/upload-m/2024-12/67639f38a78a3.png',
    name: '上传美化PPT',
    router: {
      path: '/creationqa',
      query: {
        entrance: 'beautify'
      }
    },
    bgcolor: 'linear-gradient(299deg, #0085FF 8%, #5499F2 96%)'
  }
}
